/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';

import Switch, { SwitchProps } from '@material-ui/core/Switch';

import { devWarning } from 'helpers/logger';

import style from './muiSwitch.module.scss';

interface MuiSwitchProps extends SwitchProps {
  'data-testid': string;
}

/**
 * Toggle Switch with new Design
 *
 * @extends SwitchProps from MaterialDesign
 * @see https://v4.mui.com/api/switch/
 */
const MuiSwitch = ({
  checked,
  onChange,
  name,
  disabled,
  'data-testid': testId,
  ...rest
}: MuiSwitchProps) => {
  devWarning(!testId, 'MuiSwitch', 'data-testid missing');

  return (
    <Switch
      checked={checked}
      value={checked}
      onChange={onChange}
      disabled={disabled}
      name={name}
      size="small"
      data-testid={testId}
      disableRipple
      classes={{
        thumb: style.thumb,
        track: checked ? style.trackChecked : style.track,
        sizeSmall: style.deSwitch,
        switchBase: style.switchBase,
        disabled: style.disabled,
        checked: style.checked,
        input: disabled ? 'not-allowed' : 'pointer',
      }}
      {...rest}
    />
  );
};

export default MuiSwitch;
